// ComingSoon — placeholder body rendered inside the AppShell layout.
//
// Replaces the standalone v1 stub. All authenticated routes render this
// until their Wave B+ pages land. Renders the page name as an h1 so it's
// trivially obvious which route the user is on.

import { Construction } from 'lucide-react';
import { Card } from '../ui/Card/Card';
import { EmptyState } from '../ui/EmptyState/EmptyState';

export interface ComingSoonProps {
  name: string;
  /** Optional next-wave hint (e.g. "Wave B"). */
  wave?: string;
  /** Optional override for the description text (takes precedence over `wave`). */
  message?: string;
}

export function ComingSoon({ name, wave, message }: ComingSoonProps) {
  const description = message
    ? message
    : wave
      ? `Under construction. Lands in ${wave}.`
      : 'Under construction. This page will be available once the relevant wave ships.';
  return (
    <Card>
      <EmptyState icon={Construction} title={name} description={description} />
    </Card>
  );
}
